import React, { useContext } from "react";
import { NavContext } from "../providers/NavProvider";

import { motion, AnimatePresence } from "framer-motion";

import Background from "../components/Background";
import Names from "../components/Names";
import Nav from "../components/Nav";
import Uber from "../components/Uber";
import Footer from "../components/Footer";
import Curators from "../components/Curators";
import DatenLinks from "../components/DatenLinks";

import { Seo } from "../components/Seo";

import * as styles from "../styles/index.module.scss";

const IndexPage = ({ location }) => {
  const [nav] = useContext(NavContext);
  console.log(nav.showIndex);

  return (
    <>
      <Seo />
      <Background />
      <Nav location={location} />
      <Uber />
      <DatenLinks />
      <AnimatePresence>
        {nav.showIndex && (
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 4 }}
            className={styles.container}
          >
            <Names />
            <Footer />
            <Curators />
          </motion.main>
        )}
      </AnimatePresence>
    </>
  );
};

export default IndexPage;
